<template>
    <div class="profile__main">
        <div class="profile__main__header">
            <h3 class="profile__main__header__title">
                سفارش {{id}}# / {{order?.created_at}}
            </h3>
            <a :href="route('site.profile', {section: 'orders'})" class="btn custom-btn profile__main__header__btn">
                <i class="fa fa-angle-right"></i>&nbsp; بازگشت
            </a>
        </div>
        <div class="profile__main__body">
            <div class="profile__main__account" :class="{loading}">
                <div v-if="!loading && order === null" class="alert alert-info" style="width: 100%;">سفارش یافت نشد!</div>
                <template v-if="order?.id">
                    <section class="cart" style="margin-bottom: 12px;">
                        <div class="custom-container">
                            <div class="row">
                                <div class="col-12">
                                    <div class="cart__inner" :class="{loading: loading}">
                                        <div class="cart__tab-wrapper">
                                            <div class="tab-content cart__tab-content" id="cart-tabContent">
                                                <div class="tab-pane cart__tab-pane fade show active" id="cart-shopping-basket">
                                                    <div class="cart__item" v-for="order_product in order.products">
                                                        <div class="cart__item__main">
                                                            <div class="cart__item__header">
                                                                <img
                                                                    v-if="!!order_product.product.gallery[0]"
                                                                    :src="order_product.product.gallery[0].thumb_url"
                                                                    class="cart__item__img"
                                                                    :alt="order_product.product.title"
                                                                />
                                                                <img class="cart__item__img" v-else src="/images/placeholder.png" alt="item.product.title">
                                                            </div>
                                                            <div class="cart__item__content">
                                                                <h3 class="cart__item__title">{{order_product.product.title}}</h3>
                                                            </div>
                                                        </div>
                                                        <div class="cart__item__footer">
                                                            <div class="cart__item__price">{{numberFormat(order_product.final_price)}} <span class="cart__item__price__monetary-unit">تومان</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="price-info">
                                            <div class="price-info__inner">
                                                <div class="price__info__item">
                                                    <span class="price__info__item__key">قیمت کالاها ({{order.products.length}}) :</span>
                                                    <div class="price__info__item__value">
                                                        {{numberFormat(order.subtotal)}}
                                                        <span class="price__info__item__monetary-unit">تومان</span>
                                                    </div>
                                                </div>
                                                <div class="price__info__item price__info__item--off" v-if="order.subtotal - order.total > 0">
                                                    <span class="price__info__item__key">تخفیف :</span>
                                                    <div class="price__info__item__value">
                                                        ({{Math.round((order.subtotal - order.total) / order.subtotal * 100)}}%) {{numberFormat(order.subtotal - order.total)}}
                                                        <span class="price__info__item__monetary-unit">تومان</span>
                                                    </div>
                                                </div>
                                                <div class="price__info__item price__info__item--final">
                                                    <span class="price__info__item__key">جمع قیمت محصولات: </span>
                                                    <div class="price__info__item__value">
                                                        {{numberFormat(order.total)}} <span class="price__info__item__monetary-unit">تومان</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 mt-4" :class="{loading: loading}" v-if="order?.payment_method?.key === 'DirectTransferPaymentMethod' && order?.payment_method?.text">
                                    <div class="card">
                                        <div class="card-header">
                                            <div class="card-title">پرداخت وج سفارش</div>
                                        </div>
                                        <div class="card-body" style="color: #666666; font-size: 13px; line-height: 22px">
                                            <div v-html="order.payment_method.text"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

import orderStatus from "../../../admin/utils/OrderStatus";

export default {
    name: "SingleOrder",
    props: ['id'],
    data() {
        return {
            loading: false,
            order: {},
        }
    },
    computed: {
        orderStatus() {
            return orderStatus
        },
    },
    methods: {
        async request() {
            this.loading = true;
            const token = this.token();
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };
            await this.axios.get(this.route('api.profile.orders.show', [this.id]), config).then(response => {
                this.order = response.data.data;
                this.loading = false;
            }).catch(() => {
                this.order = null;
                this.loading = false;
            });
        },
    },
    mounted() {
        this.request();
    },
}
</script>

<style scoped>

</style>
